// Single canonical grouping helper for the kitchen board: desktop columns, narrow-screen tabs,
// counts, toasts and empty states all derive groups from here so an order always lands in the
// same place on every layout.

export const SOURCE_PONESI = "CUSTOMER_APP";
export const SOURCE_LOKAL = "RESTAURANT_INTERNAL";

/** Canonical source group. Unknown/legacy sources are never silently labelled as Ponesi. */
export function sourceGroup(o) {
  const s = o?.order_source;
  if (s === SOURCE_LOKAL) return "lokal";
  if (s === SOURCE_PONESI) return "ponesi";
  return "other";
}

export const BOARD_GROUPS = {
  new: { title: "NOVE", tint: "bg-brand-red", collapsible: true },
  ponesi: { title: "PONESI", tint: "bg-brand-yellow" },
  lokal: { title: "VISTA / LOKAL", tint: "bg-brand-orange" },
  other: { title: "DRUGO", tint: "bg-slate-400", collapsible: true },
};

/** Which group a given active order belongs to (NEW/pending first, then source). */
export function boardGroup(o) {
  if (o.status === "new" || o.status === "time_change_pending") return "new";
  if (o.status === "ready") return "ready";
  if (["accepted", "preparing"].includes(o.status)) return sourceGroup(o);
  return null;
}

/**
 * VISTA / LOKAL is a paid Ponesi service: the group exists only with the canonical VISTA
 * entitlement. Safety exception — while entitlement is off but Vista orders are still actively in
 * preparation, the group stays so the kitchen can finish them (it disappears with the last one).
 */
function groupAllowed(key, counts, vista) {
  if (key !== "lokal") return true;
  return vista === true || counts.lokal > 0;
}

/** Narrow layout: tabs. PONESI stays reachable at all times so hidden orders are inspectable. */
export function tabGroups(counts, vista) {
  return Object.keys(BOARD_GROUPS).filter((k) => (!BOARD_GROUPS[k].collapsible || counts[k] > 0)
    && groupAllowed(k, counts, vista));
}

/**
 * Desktop / landscape tablet: NOVE REPLACES the PONESI column while new/pending orders exist, so
 * new orders are the primary focus and no extra column is squeezed in. PONESI orders stay fully
 * active in state; they are only not rendered (reachable via the header chip drawer).
 */
export function desktopGroups(counts, vista) {
  const main = [counts.new > 0 ? "new" : "ponesi", "lokal"].filter((k) => groupAllowed(k, counts, vista));
  return counts.other > 0 ? [...main, "other"] : main;
}

/** Target proportions; SPREMNO keeps a usable min width via its own class. */
export function groupFlex(key, hasOther) {
  if (key === "other") return 17;
  return hasOther ? 38 : 45;
}

export function visibleGroups(counts) {
  return Object.keys(BOARD_GROUPS).filter((k) => !BOARD_GROUPS[k].collapsible || counts[k] > 0);
}
